import { useMemo } from 'react'
import classes from '../index.module.scss'

export const TopPath = ({
  size,
  pathSmallRatio,
  backgroundPathOuterRadius,
  topPathFill,
  topPathStroke,
  topPathStrokeWidth,
  topPathText,
  isBottomPathSmall,
}) => {
  const getSize = useMemo(() => {
    return size - backgroundPathOuterRadius * 2
  }, [size, backgroundPathOuterRadius])

  const getHeight = useMemo(() => {
    if (isBottomPathSmall) {
      return getSize * (0.5 + 0.5 * (1 - pathSmallRatio))
    } else {
      return getSize * 0.5 * pathSmallRatio
    }
  }, [getSize, pathSmallRatio, isBottomPathSmall])

  return (
    <svg
      style={{
        width: getSize,
        height: getHeight,
        top: getHeight / 2 + backgroundPathOuterRadius,
      }}
      className={classes.topPathSvg}
    >
      {/* Border */}
      <circle
        cx={getSize / 2}
        cy={getSize / 2}
        r={getSize / 2}
        fill={topPathStroke}
      />

      {/* Content */}
      <circle
        cx={getSize / 2}
        cy={getSize / 2}
        r={getSize / 2 - topPathStrokeWidth}
        fill={topPathFill}
      />
      <foreignObject x={0} y={0} width={getSize} height={getHeight}>
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '100%',
              textAlign: 'center',
            }}
          >
            {topPathText}
          </div>
        </div>
      </foreignObject>
    </svg>
  )
}
